<section id="exemplos">
    <div class="container">
        <div class="row mt-4 mb-4">
            <div class="col-lg-12">
                <h3 class="text-center">{{ data.TITULO }}</h3>
            </div>
        </div>
        <div class="row d-flex justify-content-center">
            <div class="col-lg-4 d-flex align-items-stretch mb-4" *ngFor="let dado of data.DADOS">
                <div class="card">
                    <div class="card-body">
                        <p class="titulo">{{ dado.TITULO }}</p>
                        <p class="subtitulo mt-2">{{ dado.DESCRICAO }}</p>
                        <p class="text-muted mt-3">{{ dado.RODAPE }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>